const map = {
	"./DiscogsLookup.json": 79028,
	"./Immutable.json": 59690,
	"./Instance.json": 32241,
	"./Note.json": 3842,
	"./SinopiaLookup.json": 99823,
	"./Title.json": 9164,
	"./TitleNote.json": 10048,
	"./TitleNoteOptionalClass.json": 65124,
	"./WikidataLookup.json": 87416,
	"./Work.json": 23847,
	"./WorkTitle.json": 71623,
	"./ld4p_RT_bf2_Form.json": 30979,
	"./ld4p_RT_bf2_RareMat_RBMS.json": 11298,
	"./ld4p_RT_bf2_Title_AbbrTitle.json": 13517,
	"./nonUniqueValueTemplateRefs.json": 97259,
	"./notFoundValueTemplateRefs.json": 41918,
	"./propertyURIRepeated.json": 50981,
	"./testing_ambiguous_class_multiple_non_suppressible.json": 34647,
	"./testing_ambiguous_class_non_suppressible.json": 26156,
	"./testing_ambiguous_class_typed_sibling.json": 69352,
	"./testing_cycle_a.json": 39495,
	"./testing_cycle_b.json": 18054,
	"./testing_dupe_properties.json": 55073,
	"./testing_inputs.json": 22882,
	"./testing_literal.json": 5062,
	"./testing_literalValidation.json": 29557,
	"./testing_lookups.json": 3086,
	"./testing_merge_defaults_host.json": 80451,
	"./testing_merge_defaults_match.json": 94702,
	"./testing_merge_defaults_sibling.json": 121,
	"./testing_multiple_class_inputs.json": 20728,
	"./testing_multiple_class_literal.json": 18844,
	"./testing_multiple_property_uris.json": 78745,
	"./testing_named_node_multi_prop.json": 96233,
	"./testing_named_node_multi_prop_host.json": 91280,
	"./testing_ordered.json": 93036,
	"./testing_required_single_default_host.json": 39612,
	"./testing_rich_uri.json": 83104,
	"./testing_rich_uri2.json": 33818,
	"./testing_self_cycle.json": 47344,
	"./testing_shared_optional_class.json": 87424,
	"./testing_suppress_language.json": 62591,
	"./testing_suppressed_uri.json": 79248,
	"./testing_suppressed_uri2.json": 63626,
	"./testing_suppressible.json": 60156,
	"./testing_suppressible_ambiguous.json": 12323,
	"./testing_typed_rich_uri.json": 55829,
	"./testing_uri.json": 24515,
	"./uber_template1.json": 46984,
	"./uber_template2.json": 32901,
	"./uber_template3.json": 96218,
	"./uber_template4.json": 82903,
	"./uber_template5.json": 2180,
	"./untyped_id_template.json": 10208,
	"./versioned_cycle_a.json": 18050,
	"./versioned_cycle_b.json": 52307,
	"./versioned_title_v1.json": 95686,
	"./versioned_title_v2.json": 47879
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74689;